import { render, staticRenderFns } from "./allProductHistory.vue?vue&type=template&id=03b6d3d2&scoped=true"
import script from "./allProductHistory.vue?vue&type=script&lang=js"
export * from "./allProductHistory.vue?vue&type=script&lang=js"
import style0 from "./allProductHistory.vue?vue&type=style&index=0&id=03b6d3d2&prod&scoped=true&lang=scss"
import style1 from "./allProductHistory.vue?vue&type=style&index=1&id=03b6d3d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b6d3d2",
  null
  
)

export default component.exports